// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--16yiN","title":"hero-module--title--FQiUY","subtitle":"hero-module--subtitle--25hor","image":"hero-module--image--3XfBU"};